import { render, staticRenderFns } from "./module_detail.vue?vue&type=template&id=8b554f26&scoped=true&"
import script from "./module_detail.vue?vue&type=script&lang=js&"
export * from "./module_detail.vue?vue&type=script&lang=js&"
import style0 from "./module_detail.vue?vue&type=style&index=0&id=8b554f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b554f26",
  null
  
)

export default component.exports